// Landing page translations - Privacy Policy, Terms, App Store badges, and Guest Mode
export const landing = {
  en: {
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    downloadAppStore: 'Download on the App Store',
    getGooglePlay: 'Get it on Google Play',
    playAsGuest: 'Play as Guest',
    startPlaying: 'Begin Today’s Journey',
    heroLead: 'Step into Scripture through play, reflection, and reward.',
    heroBody: 'Answer warm daily challenges, unlock verse reveals, and build a Scripture journey your household can share.',
    masteryEyebrow: 'A living Bible adventure',
    journeyBadge: 'Kingdom Journey',
    ctaEyebrow: 'Today’s Scripture Quest',
    verseEyebrow: 'Verse Reveal',
    verseSupport: 'Begin with Scripture, then continue into a guided quiz journey.',
    featureVerseReveal: 'Verse reveals',
    featureStreaks: 'Warm streaks',
    featureFamily: 'Family safe',
    versePreviewLabel: 'Tap to expand today’s scripture',
    verseCollapseLabel: 'Tap to return to the preview',
  },
  es: {
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    downloadAppStore: 'Descargar en el App Store',
    getGooglePlay: 'Disponible en Google Play',
    playAsGuest: 'Jugar como Invitado',
    startPlaying: 'Comenzar el Viaje de Hoy',
    heroLead: 'Entra en la Escritura con juego, reflexión y recompensa.',
    heroBody: 'Responde desafíos diarios, descubre versículos y crea un viaje bíblico para compartir en casa.',
    masteryEyebrow: 'Una aventura bíblica viva',
    journeyBadge: 'Viaje del Reino',
    ctaEyebrow: 'Búsqueda bíblica de hoy',
    verseEyebrow: 'Revelación del versículo',
    verseSupport: 'Comienza con la Escritura y continúa en un viaje guiado de preguntas.',
    featureVerseReveal: 'Versículos revelados',
    featureStreaks: 'Rachas cálidas',
    featureFamily: 'Seguro para familia',
    versePreviewLabel: 'Toca para expandir la Escritura de hoy',
    verseCollapseLabel: 'Toca para volver a la vista previa',
  },
  fr: {
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions d\'Utilisation',
    downloadAppStore: 'Télécharger sur l\'App Store',
    getGooglePlay: 'Disponible sur Google Play',
    playAsGuest: 'Jouer en Invité',
    startPlaying: 'Commencer le Voyage du Jour',
    heroLead: 'Entrez dans l’Écriture par le jeu, la réflexion et la récompense.',
    heroBody: 'Répondez à des défis quotidiens, révélez des versets et construisez un parcours biblique à partager en famille.',
    masteryEyebrow: 'Une aventure biblique vivante',
    journeyBadge: 'Voyage du Royaume',
    ctaEyebrow: 'Quête biblique du jour',
    verseEyebrow: 'Révélation du verset',
    verseSupport: 'Commencez avec l’Écriture, puis continuez dans un quiz guidé.',
    featureVerseReveal: 'Versets révélés',
    featureStreaks: 'Séries douces',
    featureFamily: 'Pour la famille',
    versePreviewLabel: 'Touchez pour développer l’Écriture du jour',
    verseCollapseLabel: 'Touchez pour revenir à l’aperçu',
  },
  de: {
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    downloadAppStore: 'Laden im App Store',
    getGooglePlay: 'Jetzt bei Google Play',
    playAsGuest: 'Als Gast Spielen',
    startPlaying: 'Heutige Reise Beginnen',
    heroLead: 'Erlebe die Schrift durch Spiel, Nachdenken und Belohnung.',
    heroBody: 'Beantworte tägliche Aufgaben, entdecke Verse und baue eine Bibelreise für dein Zuhause auf.',
    masteryEyebrow: 'Ein lebendiges Bibelabenteuer',
    journeyBadge: 'Königreich-Reise',
    ctaEyebrow: 'Heutige Schrift-Quest',
    verseEyebrow: 'Versenthüllung',
    verseSupport: 'Beginne mit der Schrift und gehe weiter in eine geführte Quizreise.',
    featureVerseReveal: 'Versenthüllungen',
    featureStreaks: 'Warme Serien',
    featureFamily: 'Familienfreundlich',
    versePreviewLabel: 'Tippen, um die heutige Schriftstelle zu erweitern',
    verseCollapseLabel: 'Tippen, um zur Vorschau zurückzukehren',
  },
  pt: {
    privacyPolicy: 'Política de Privacidade',
    termsOfService: 'Termos de Serviço',
    downloadAppStore: 'Baixar na App Store',
    getGooglePlay: 'Disponível no Google Play',
    playAsGuest: 'Jogar como Convidado',
    startPlaying: 'Começar a Jornada de Hoje',
    heroLead: 'Entre nas Escrituras com jogo, reflexão e recompensa.',
    heroBody: 'Responda desafios diários, revele versículos e construa uma jornada bíblica para sua casa.',
    masteryEyebrow: 'Uma aventura bíblica viva',
    journeyBadge: 'Jornada do Reino',
    ctaEyebrow: 'Busca bíblica de hoje',
    verseEyebrow: 'Revelação do versículo',
    verseSupport: 'Comece com a Escritura e continue em uma jornada guiada de quiz.',
    featureVerseReveal: 'Versículos revelados',
    featureStreaks: 'Sequências calorosas',
    featureFamily: 'Seguro para família',
    versePreviewLabel: 'Toque para expandir a Escritura de hoje',
    verseCollapseLabel: 'Toque para voltar à prévia',
  },
  ru: {
    privacyPolicy: 'Политика Конфиденциальности',
    termsOfService: 'Условия Использования',
    downloadAppStore: 'Загрузить в App Store',
    getGooglePlay: 'Доступно в Google Play',
    playAsGuest: 'Играть как Гость',
    startPlaying: 'Начать Сегодняшний Путь',
    heroLead: 'Войдите в Писание через игру, размышление и награду.',
    heroBody: 'Отвечайте на ежедневные задания, открывайте стихи и стройте библейское путешествие для семьи.',
    masteryEyebrow: 'Живое библейское приключение',
    journeyBadge: 'Путь Царства',
    ctaEyebrow: 'Сегодняшний поиск в Писании',
    verseEyebrow: 'Открытие стиха',
    verseSupport: 'Начните с Писания, затем продолжайте направленную викторину.',
    featureVerseReveal: 'Открытия стихов',
    featureStreaks: 'Добрые серии',
    featureFamily: 'Для семьи',
    versePreviewLabel: 'Нажмите, чтобы раскрыть сегодняшнее место Писания',
    verseCollapseLabel: 'Нажмите, чтобы вернуться к краткому виду',
  },
  tl: {
    privacyPolicy: 'Patakaran sa Privacy',
    termsOfService: 'Mga Tuntunin ng Serbisyo',
    downloadAppStore: 'I-download sa App Store',
    getGooglePlay: 'Kunin sa Google Play',
    playAsGuest: 'Maglaro bilang Bisita',
    startPlaying: 'Simulan ang Paglalakbay Ngayon',
    heroLead: 'Pumasok sa Kasulatan sa pamamagitan ng laro, pagninilay, at gantimpala.',
    heroBody: 'Sagutin ang araw-araw na hamon, buksan ang mga talata, at bumuo ng paglalakbay sa Biblia para sa pamilya.',
    masteryEyebrow: 'Buhay na pakikipagsapalaran sa Biblia',
    journeyBadge: 'Paglalakbay ng Kaharian',
    ctaEyebrow: 'Quest sa Kasulatan ngayon',
    verseEyebrow: 'Pagbubunyag ng talata',
    verseSupport: 'Magsimula sa Kasulatan at magpatuloy sa gabay na quiz journey.',
    featureVerseReveal: 'Mga talatang bubuksan',
    featureStreaks: 'Mainit na streaks',
    featureFamily: 'Para sa pamilya',
    versePreviewLabel: 'I-tap para palawakin ang talata ngayon',
    verseCollapseLabel: 'I-tap para bumalik sa preview',
  },
  it: {
    privacyPolicy: 'Informativa sulla Privacy',
    termsOfService: 'Termini di Servizio',
    downloadAppStore: 'Scarica su App Store',
    getGooglePlay: 'Disponibile su Google Play',
    playAsGuest: 'Gioca come Ospite',
    startPlaying: 'Inizia il Viaggio di Oggi',
    heroLead: 'Entra nella Scrittura con gioco, riflessione e ricompensa.',
    heroBody: 'Rispondi a sfide quotidiane, rivela versetti e costruisci un viaggio biblico da condividere in casa.',
    masteryEyebrow: 'Un’avventura biblica viva',
    journeyBadge: 'Viaggio del Regno',
    ctaEyebrow: 'Quest biblica di oggi',
    verseEyebrow: 'Rivelazione del versetto',
    verseSupport: 'Inizia con la Scrittura e continua in un quiz guidato.',
    featureVerseReveal: 'Versetti rivelati',
    featureStreaks: 'Serie incoraggianti',
    featureFamily: 'Per la famiglia',
    versePreviewLabel: 'Tocca per espandere la Scrittura di oggi',
    verseCollapseLabel: 'Tocca per tornare all’anteprima',
  },
  am: {
    privacyPolicy: 'የግላዊነት ፖሊሲ',
    termsOfService: 'የአገልግሎት ውሎች',
    downloadAppStore: 'በ App Store ላይ አውርድ',
    getGooglePlay: 'በ Google Play ላይ ያግኙ',
    playAsGuest: 'እንደ እንግዳ ተጫወት',
    startPlaying: 'የዛሬውን ጉዞ ጀምር',
    heroLead: 'በጨዋታ፣ በማሰላሰል እና በሽልማት ወደ ቃሉ ይግቡ።',
    heroBody: 'ዕለታዊ ጥያቄዎችን ይመልሱ፣ ቃላትን ይግለጹ እና ለቤተሰብዎ የመጽሐፍ ቅዱስ ጉዞ ይገንቡ።',
    masteryEyebrow: 'ሕያው የመጽሐፍ ቅዱስ ጀብዱ',
    journeyBadge: 'የመንግሥት ጉዞ',
    ctaEyebrow: 'የዛሬ የቃል ፍለጋ',
    verseEyebrow: 'የቃል መግለጫ',
    verseSupport: 'በቃሉ ይጀምሩ እና ወደ ተመራ ጥያቄ ጉዞ ይቀጥሉ።',
    featureVerseReveal: 'የቃል መግለጫዎች',
    featureStreaks: 'ሞቅ ያሉ ተከታታዮች',
    featureFamily: 'ለቤተሰብ ደህና',
    versePreviewLabel: 'የዛሬውን ቃል ለማስፋት ይጫኑ',
    verseCollapseLabel: 'ወደ ቅድመ እይታው ለመመለስ ይጫኑ',
  },
  ko: {
    privacyPolicy: '개인정보 보호정책',
    termsOfService: '서비스 약관',
    downloadAppStore: 'App Store에서 다운로드',
    getGooglePlay: 'Google Play에서 받기',
    playAsGuest: '게스트로 플레이',
    startPlaying: '오늘의 여정 시작',
    heroLead: '놀이와 묵상, 보상을 통해 말씀 안으로 들어가세요.',
    heroBody: '매일의 도전에 답하고, 말씀을 열어 보며, 가족과 함께 나눌 성경 여정을 만들어 가세요.',
    masteryEyebrow: '살아 있는 성경 모험',
    journeyBadge: '킹덤 여정',
    ctaEyebrow: '오늘의 말씀 퀘스트',
    verseEyebrow: '말씀 공개',
    verseSupport: '말씀으로 시작한 뒤 안내되는 퀴즈 여정을 계속하세요.',
    featureVerseReveal: '말씀 공개',
    featureStreaks: '따뜻한 연속 기록',
    featureFamily: '가족 친화',
    versePreviewLabel: '오늘의 말씀을 펼치려면 탭하세요',
    verseCollapseLabel: '미리보기로 돌아가려면 탭하세요',
  },
};
